module.exports = __webpack_public_path__ + "static/media/3.7b6eba08.jpg";